'use client';

import { createContext } from 'react';

export const SiteConfig = createContext(null);

export function SiteConfigProvider({ value, children }) {
  return <SiteConfig.Provider value={value}>{children}</SiteConfig.Provider>;
}
